export type Category = {
  title: string
  sectorKey: string
}

const categories: { [key: string]: Category } = {
  all: {
    title: 'Tudo',
    sectorKey: 'general',
  },
  generalQuestionnaires: {
    title: 'Questionários',
    sectorKey: 'general',
  },
  healthAttendances: {
    title: 'Atendimentos',
    sectorKey: 'health',
  },
  healthAttendanceOccurrences: {
    title: 'Ocorrências de saúde',
    sectorKey: 'health',
  },
  healthCitizens: {
    title: 'Cidadãos',
    sectorKey: 'health',
  },
  healthIndividualProfile: {
    title: 'Cadastro individual',
    sectorKey: 'health',
  },
  healthResidences: {
    title: 'Domicílios',
    sectorKey: 'health',
  },
  healthTeam: {
    title: 'Equipes de saúde',
    sectorKey: 'health',
  },
  healthProcedures: {
    title: 'Exames e procedimentos',
    sectorKey: 'health',
  },
  healthImmunobiologicals: {
    title: 'Imunizações',
    sectorKey: 'health',
  },
  healthPrescribedDrugs: {
    title: 'Medicamentos prescritos',
    sectorKey: 'health',
  },
  healthProfessional: {
    title: 'Profissionais de saúde',
    sectorKey: 'health',
  },
  healthUnit: {
    title: 'Unidades de saúde',
    sectorKey: 'health',
  },
  healthHomeVisit: {
    title: 'Visitas domiciliares',
    sectorKey: 'health',
  },
  economyLegalEntities: {
    title: 'Empresas',
    sectorKey: 'economy',
  },
  registerManagement: {
    title: 'Ferramentas',
    sectorKey: 'management',
  },
  systemManagement: {
    title: 'Sistema',
    sectorKey: 'management',
  },
}

export const sentinelVariableCategorySections = [
  {
    key: 'general',
    title: 'Geral',
    categoryKeys: ['all', 'generalQuestionnaires', 'registerManagement', 'systemManagement'],
  },
  {
    key: 'health',
    title: 'Saúde',
    categoryKeys: [
      'healthAttendances',
      'healthAttendanceOccurrences',
      'healthCitizens',
      'healthIndividualProfile',
      'healthResidences',
      'healthTeam',
      'healthProcedures',
      'healthImmunobiologicals',
      'healthPrescribedDrugs',
      'healthProfessional',
      'healthUnit',
      'healthHomeVisit',
    ],
  },
  {
    key: 'economy',
    title: 'Economia',
    categoryKeys: ['economyLegalEntities'],
  },
] as const

export default categories
